import * as storageService from 'services/storage.service';
import userService from 'resources/user/user.service';
import { AGENT_DELETED } from 'resources/user/user.constants';


export const extendDocument = async (document) => {
  if (!document) {
    return null;
  }

  try {
    const filePath = document.file_url;
    const documentBucket = filePath.substr(0, filePath.indexOf('/'));
    const documentPath = filePath.substring(filePath.indexOf('/') + 1);
    const url = await storageService.getSignedUrl({ bucket: documentBucket, path: documentPath });
    const uploader = await userService.findById(document.uploader_id);

    return {
      ...document,
      url,
      uploader: {
        first_name: uploader ? uploader.first_name : AGENT_DELETED.FIRST_NAME,
        last_name: uploader ? uploader.last_name : AGENT_DELETED.LAST_NAME,
      },
    };
  } catch (error) {
    return {
      ...document,
      url: null,
      uploader: null,
    };
  }
};

export const extentDocuments = async (documents) => {
  if (!documents) {
    return [];
  }

  const documentsToExtend = Array.isArray(documents) ? documents : [documents];

  return documentsToExtend && Promise.allSettled(
    documentsToExtend.map(async (document) => extendDocument(document)),
  ).then((results) => results.filter((result) => result.status !== 'rejected').map((result) => result.value));
};
